import { baseAbsolutaDaApi, chamar } from '@/services/geo-engine/client';
/** Uma função por endpoint público consumido. Sem lógica além da forma da requisição. */
const segmento = encodeURIComponent;
export function verificarSaude(sinal) {
    // O health responde 503 com corpo válido quando o banco está indisponível.
    return chamar({
        metodo: 'GET',
        caminho: '/health',
        autenticada: false,
        statusAdicionaisAceitos: [503],
        sinal,
    });
}
export function listarCamadas(sinal) {
    return chamar({ metodo: 'GET', caminho: '/camadas', sinal });
}
export function obterCamada(id, sinal) {
    return chamar({ metodo: 'GET', caminho: `/camadas/${segmento(id)}`, sinal });
}
/**
 * URL do tile MVT da camada. Aceita coordenadas numéricas ou os marcadores `{z}`/`{x}`/`{y}`,
 * que o MapLibre substitui ao compor a fonte vetorial.
 */
export function obterUrlTile(id, z, x, y) {
    return `${baseAbsolutaDaApi()}/camadas/${segmento(id)}/tiles/${z}/${x}/${y}.mvt`;
}
export function listarFeicoes(id, consulta = {}, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: `/camadas/${segmento(id)}/feicoes`,
        parametros: {
            limit: consulta.limit,
            cursor: consulta.cursor ?? undefined,
            bbox: consulta.bbox,
            filtro: consulta.filtros,
        },
        sinal,
    });
}
export function obterFeicao(id, feicaoId, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: `/camadas/${segmento(id)}/feicoes/${feicaoId}`,
        sinal,
    });
}
export function obterGeometria(id, feicaoId, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: `/camadas/${segmento(id)}/feicoes/${feicaoId}/geometria`,
        sinal,
    });
}
export function listarValores(id, atributo, q, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: `/camadas/${segmento(id)}/valores/${segmento(atributo)}`,
        parametros: { q: q === undefined || q === '' ? undefined : q },
        sinal,
    });
}
export function obterEstatisticas(id, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: `/camadas/${segmento(id)}/estatisticas`,
        sinal,
    });
}
export function calcularBuffer(geometria, distanciaMetros, sinal) {
    return chamar({
        metodo: 'POST',
        caminho: '/operacoes/buffer',
        corpo: { geometria, distancia_metros: distanciaMetros },
        sinal,
    });
}
export function calcularIntersecao(geometriaA, geometriaB, sinal) {
    return chamar({
        metodo: 'POST',
        caminho: '/operacoes/intersecao',
        corpo: { geometria_a: geometriaA, geometria_b: geometriaB },
        sinal,
    });
}
